/* Actions are asynchronous methods. Any change to the data that implies an async function such as a
http request or a timeout, will be written as an action and will be 'dispatched' from the component using the data. */  

import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource);

export default {
    requestTestData: (context) => {
        setTimeout(() => {
            Vue.http.get('https://jsonplaceholder.typicode.com/comments').then(response => {  
                context.commit("setTestData", response.data);
            },
            error => {
                console.log(error);
            })
        }, 2000)
    }
}

